<template>
  <div id="app">
    <app-navbar/>
    <router-view/>
    <app-footer v-if="!homePage"/>
  </div>
</template>

<script>
import Navbar from '@/components/partials/Navbar'
import Footer from '@/components/partials/Footer'
import Vue from 'vue'
import Buefy from 'buefy'

Vue.use(Buefy)

export default {
  components: {
    'app-navbar': Navbar,
    'app-footer': Footer
  },
  beforeMount () {
    this.$store.dispatch('sessions/update')
  },
  created () {
    if (!localStorage.getItem('cookies')) {
      this.$buefy.snackbar.open({
        message: `We use cookies to enhance your experience, analyze site traffic and for marketing purposes. <a href="/policy">Learn more</a>`,
        type: 'is-success',
        position: 'is-bottom',
        actionText: 'Accept',
        indefinite: true,
        onAction: () => {
          localStorage.setItem('cookies', true)
        }
      })
    }
  },
  computed: {
    homePage () {
      return this.$route.path === '/'
    }
  }
}
</script>

<style lang="scss">
</style>
